/** User documentation site, linked from the topbar help menu. */
export const DOCS_URL: string =
    import.meta.env?.APP_DOCUMENTATION_URL ||
    'https://production-dc-documentation.web.app/'
